import { onDomLoaded } from '../utils/dom';
export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.hook('app:mounted', () => {
    onDomLoaded();
  });
});
